import { Spin, theme, Typography } from "antd";
import { FC } from "react";
import { styled } from "styled-components";
import CenterContent from "../layouts/CenterContent";

const { Title } = Typography;

const InitiatingCallScreen: FC = () => {
  const { token } = theme.useToken();

  return (
    <CenterContent $backgroundColor={token.colorPrimary} $gap={token.sizeXXL}>
      <Title level={2} style={{ color: token.colorBgContainer }}>Initiating call...</Title>
      <StyledSpin size="large" />
    </CenterContent>
  );
};

export default InitiatingCallScreen;

const StyledSpin = styled(Spin)`
  .ant-spin-dot-holder {
    color: ${p => p.theme.colorBgContainer};
  }
`;
